<template>
  <div>
    <SearchableTable
      :panel-header="'Landkreise'"
      :panel-route="'AddDistrict'"
      :show-search-bar="true"
      :table-data="filteredDistricts"
      :table-meta-data="tableMetaData"
      :query-string="'setDistrictSearchQuery'"
      :initial-search-query="districtSearchQuery"
      :row-click="triggerView"
      :default-sort="['attributes.name', 'asc']"
    />
  </div>
</template>

<script>
import { queryLocationByType } from "@/lib/Query";
import { mapGetters } from "vuex";
import SearchableTable from "../helperComponents/SearchableTable.vue";

export default {
	name: "DistrictsComponent",
	components: { SearchableTable },
	data() {
		return {
			districts: [],
			tableMetaData: [
				{ "id": 0, "type": "string", "label": "Name", "field": "name", "sortField": "attributes.name" },
				{ "id": 1, "type": "string", "label": "Email", "field": "email", "sortField": "attributes.email" },
				{ "id": 2, "type": "string", "label": "Ort", "field": "location", "sortField": "attributes.location" }
			]
		}
	},
	computed: {
		...mapGetters({
			districtSearchQuery: "getDistrictSearchQuery"
		}),
		filteredDistricts() {
			const query = this.districtSearchQuery.toLowerCase();
			if (!query) return this.districts;
			return this.districts.filter(district => {
				const a = district.attributes;
				return [ a.name, a.email, a.location ].some(value =>
					value && value.toLowerCase().includes(query));
			});
		}
	},
	async created() {
		this.districts = await queryLocationByType("district")
	},
	methods: {
		triggerView(district) {
			this.$router.push(
				{ name: "ViewDistrict", params: { id: district.id, data: district } });
		}
	}
}
</script>

<style scoped></style>
